import { getPreloaderFnContext } from '@confluence/query-preloader-tools/entry-points/preloaderFnContext';
import { query } from '@confluence/query-preloader-tools/entry-points/graphql';
import { getIsSiteAdminFromQuery } from '@confluence/current-user/entry-points/getIsSiteAdminFromQuery';
import { getIsProductAdminFromQuery } from '@confluence/current-user/entry-points/getIsProductAdminFromQuery';
import { ssrPrepareErrorsClient } from '@confluence/ssr-utilities/entry-points/SSRPrepareErrorsClient';

import { DisplayConditionsSpaceAdminQuery } from './DisplayConditionsSpaceAdminQuery.graphql';
import type { UseStaticContextProps } from './useStaticContext';
import { UserPrivilegeQuery } from './UserPrivilegeQuery.graphql';

export async function preloadUseStaticContext({ spaceKey }: Partial<UseStaticContextProps>) {
	const { isLoggedIn } = getPreloaderFnContext();

	try {
		// eslint-disable-next-line check-preloaders/no-promise-all
		const [{ data: spaceAdminData }, { data: privilegeData }] = await Promise.all([
			query({
				/* @ts-expect-error -- http://go/cfe-use-relay-artifacts */
				query: DisplayConditionsSpaceAdminQuery,
				variables: { spaceKey },
			}),
			/* @ts-expect-error -- http://go/cfe-use-relay-artifacts */
			query({ query: UserPrivilegeQuery }),
		]);

		const isSpaceAdmin = (spaceAdminData as any)?.space?.currentUser?.isAdmin;
		const isSiteAdmin = getIsSiteAdminFromQuery(privilegeData as any);
		const isAdmin = isSiteAdmin || getIsProductAdminFromQuery(privilegeData as any);
		return {
			isSpaceAdmin,
			isLoggedIn,
			isAdmin,
			isSiteAdmin,
		};
	} catch (e) {
		ssrPrepareErrorsClient.submitError(
			new Error(`Cannot preload data for useStaticContext, using defaults for SSR: ${e.message}`),
		);

		return {
			isLoggedIn,
			isSpaceAdmin: false,
			isAdmin: false,
			isSiteAdmin: false,
		};
	}
}
